import { AppConfig } from '../config/app-config';
import { registerBackendUrlAsProtectedResource } from '../services/authentication/auth.service';

// Under MSAL, login is no longer force-triggered eagerly here: MsalGuard (on protected routes) and
// MsalInterceptor (on protected API calls) handle the redirect to Microsoft login automatically.
// The current user is set later, once InteractionStatus.None is reached (see app.component.ts).
//
// IMPORTANT: do not add any call to a PROTECTED backend endpoint (one matching protectedResourceMap)
// here. APP_INITIALIZER executes before Angular bootstrap/router/MsalGuard are ready, so MsalInterceptor
// would try to trigger an interactive login redirect way too early. This can leave a stale
// "interaction_in_progress" lock (in sessionStorage) that silently blocks the *real* login redirect
// triggered later by MsalGuard on route activation — resulting in "nothing happens, no login page".
// Any protected data fetch must happen after authentication (see AppComponent.ngOnInit).
export const initializer =
	(config: AppConfig): (() => Promise<any>) =>
	(): Promise<any> =>
		// eslint-disable-next-line no-async-promise-executor
		new Promise(async (resolve, reject) => {
			try {
				await config.load();
				// Now that AppConfig.instance.backendUrl is available, register it as a protected
				// resource for MsalInterceptor (see registerBackendUrlAsProtectedResource for why this
				// can't be done inside MSALInterceptorConfigFactory itself).
				registerBackendUrlAsProtectedResource();
				resolve(true);
			} catch (error) {
				console.log(error);
				reject(error);
			}
		});
